import { render, staticRenderFns } from "./SignatureHome.handler.vue?vue&type=template&id=6d0c2f87&"
import script from "./SignatureHome.handler.vue?vue&type=script&lang=ts&"
export * from "./SignatureHome.handler.vue?vue&type=script&lang=ts&"
import style0 from "./SignatureHome.handler.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports